import moment from 'moment-timezone';

// tslint:disable: max-classes-per-file
import {
  DriveWealthTransactionType,
  ITransactionDetailResponse,
  ITransactionInstrument,
  ITransactionsResponse,
} from '../responses/transactions.response';
import { PaginationMetadataViewModel } from './pagination';

export interface ITransactionDetail {
  accountAmount: number;
  accountBalance: number;
  type: string;
  quantity: number;
  price: number;
  instrument: ITransactionInstrument;
  amount: number;
  source: string;
  date: string;
  hour: string;
}

export interface ITransactions {
  transactions: TransactionDetailViewModel[];
  pagination: PaginationMetadataViewModel;
}

export class TransactionsViewModel implements ITransactions {
  static fromJSON(json: ITransactionsResponse): TransactionsViewModel {
    return new TransactionsViewModel(
      json.Transactions.map((transaction) =>
        TransactionDetailViewModel.fromJSON(transaction),
      ),
      PaginationMetadataViewModel.fromJSON(json.pagination_metadata),
    );
  }

  constructor(
    public transactions: TransactionDetailViewModel[],
    public pagination: PaginationMetadataViewModel,
  ) {}
}

export class TransactionDetailViewModel implements ITransactionDetail {
  static fromJSON(
    json: ITransactionDetailResponse,
  ): TransactionDetailViewModel {
    return new TransactionDetailViewModel(
      json.account_amount,
      json.account_balance,
      DriveWealthTransactionType[json.fin_tran_type_id] || '-',
      json.fill_quantity,
      json.fill_price,
      json.instrument,
      json.tran_amount,
      json.tran_source,
      moment(json.tran_when).format('L'),
      moment(json.tran_when).format('hh:mm:ss'),
    );
  }

  constructor(
    public accountAmount: number,
    public accountBalance: number,
    public type: string,
    public quantity: number,
    public price: number,
    public instrument: ITransactionInstrument,
    public amount: number,
    public source: string,
    public date: string,
    public hour: string,
  ) {}
}
